export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/837e258702481769ad64684ae735d0c9.svg";